import RouteTemplate from 'ember-route-template';
import EsportsBanner from '../../components/layout/banner/esports';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import EsportsNewsComponent from '../../components/layout/news/esports-news';
import EsportsMatchResultsBanner from '../../components/layout/banner/esports-match-results';
import LiveScoreStrip from '../../components/esports/live-score-strip';

export default RouteTemplate(
  <template>
    <LiveScoreStrip />
    <EsportsBanner />
    <LiveNewsTicker />
    <EsportsMatchResultsBanner />
    <EsportsNewsComponent @articles={{@model.articles}} @popularPosts={{@model.popularPosts}} />
  </template>
);
